import type { DocPageContent } from '../docs-content'

const page = {
  order: 21,
  slug: 'settings',
  title: '设置',
  description: '通用、时间线、AI、存储、语言和快捷键偏好设置。',
  category: '参考',
  sections: [
    {
      title: '通用设置',
      items: [
        '开启或关闭自动保存。',
        '设置自动保存间隔。',
        '设置撤销历史深度。',
        '选择界面语言。',
      ],
    },
    {
      title: '时间线设置',
      items: [
        '选择是否默认启用吸附。',
        '显示或隐藏波形图。',
        '显示或隐藏胶片条。',
        '启用或禁用在导入和显示时的胶片条提取。',
      ],
    },
    {
      title: 'AI 与存储设置',
      items: [
        '设置 AI 说明文字采样间隔。',
        '选择默认说明文字样式。',
        '生成缺失的代理文件。',
        '清除项目缓存、重新生成缩略图或删除代理文件。',
        '检查、清除或卸载本地 AI 模型缓存和运行时。',
      ],
    },
  ],
} satisfies DocPageContent

export default page